export type Gender = 'Male' | 'Female' | 'Other' | '';

export const GENDER_OPTIONS: Exclude<Gender, ''>[] = ['Male', 'Female', 'Other'];

/** A student record as the app uses it. */
export interface Student {
  id: string;
  ownerId: string;
  fullNames: string;
  gender: Gender;
  className: string;
  fatherName: string;
  fatherPhone: string;
  motherName: string;
  motherPhone: string;
  note: string;
  createdAtMs: number;
  updatedAtMs: number;
}

/** A row exactly as it is stored in the Supabase `students` table. */
export interface StudentRow {
  id: string;
  owner_id: string;
  full_names: string | null;
  gender: string | null;
  class_name: string | null;
  father_name: string | null;
  father_phone: string | null;
  mother_name: string | null;
  mother_phone: string | null;
  note: string | null;
  created_at: string | null;
  updated_at: string | null;
}

/** Everything a user can type into the Add / Edit Student form. */
export interface StudentFormValues {
  fullNames: string;
  gender: Gender;
  className: string;
  fatherName: string;
  fatherPhone: string;
  motherName: string;
  motherPhone: string;
  note: string;
}

export const emptyStudentForm: StudentFormValues = {
  fullNames: '',
  gender: '',
  className: '',
  fatherName: '',
  fatherPhone: '',
  motherName: '',
  motherPhone: '',
  note: ''
};

export type SortKey = 'newest' | 'oldest' | 'name-asc' | 'name-desc' | 'class-asc';

export interface ExportOptions {
  scope: 'all' | 'class' | 'gender';
  className: string;
  gender: Exclude<Gender, ''> | '';
}
